import style from './Object.module.css';

import DerivedObject from './DerivedObject';
import ExternalObject from './ExternalObject';

const Object = ({ objects }) => {
  return (
    <div className={style.container}>
      {objects?.some((item) => item.derived) && (
        <div className={style.objectsContainer}>
          <div className={style.title}>Полученные образцы</div>
          {objects
            ?.filter((item) => item.derived)
            ?.map((object, index) => {
              return <DerivedObject key={object?.id + index} object={object} index={index} />;
            })}
        </div>
      )}
      {objects?.some((item) => !item.derived) && (
        <div className={style.objectsContainer}>
          <div className={style.title}>Внешние образцы</div>
          {objects
            ?.filter((item) => !item.derived)
            ?.map((object, index) => {
              return (
                <ExternalObject
                  key={object?.id + index}
                  object={object}
                  index={(objects?.filter((item) => item.derived)?.length ?? 0) + index}
                />
              );
            })}
        </div>
      )}
    </div>
  );
};

export default Object;
